import React from 'react';
import './base.scss';
import { LocaleProvider } from './util/i18n';
import { Route, Routes } from 'react-router-dom';
import Header from './component/header';
import { HelmetProvider } from 'react-helmet-async';
import { PayloadProvider, usePayload } from './util/token';
import Dashboard from './page/Dashboard';
import Nav from './component/nav';
import Login from './page/Login';
import Toast from './component/toast';
import { CrumbsProvider } from './component/breadcrumbs';
import UserGrid from './page/user/Grid';
import UserEdit from './page/user/Edit';
import Me from './page/user/Me';
import RoleGrid from './page/role/Grid';
import RoleEdit from './page/role/Edit';
import ConfigGeneral from './page/config/General';
import ConfigEmail from './page/config/Email';
import ConfigStock from './page/config/Stock';
import Dispatch from './page/stock/Dispatch';
import History from './page/stock/History';
import ConfigInventory from './page/config/Inventory';
import ConfigAPI from './page/config/API';
import Forecast from './page/Forecast';
import PurchaseOrderInventory from './page/inventory/PurchaseOrder';
import Logs from './page/user/Logs';
import Shipment from './page/inventory/Shipment';
import Rack from './page/stock/Rack';
import { TagProvider } from './util/tag';
import PurchaseOrders from './page/erp/PurchaseOrders';
import PurchaseOrder from './page/erp/PurchaseOrder';
import SalesOrders from './page/erp/SalesOrders';
import SalesOrder from './page/erp/SalesOrder';
import SalesShipments from './page/erp/SalesShipments';
import SalesShipment from './page/erp/SalesShipment';
import CreditMemos from './page/erp/CreditMemos';
import CreditMemo from './page/erp/CreditMemo';
import Suppliers from './page/erp/Suppliers';
import Supplier from './page/erp/Supplier';
import EmailQueue from './page/email/Queue';
import EmailTmplGrid from './page/email/template/Grid';
import EmailTmplEdit from './page/email/template/Edit';
import Inventory from './page/stock/Inventory';

export default function App() {
    React.useEffect(() => {
        if ('ontouchend' in window) {
            document.documentElement.classList.add('touchevents');
        } else {
            document.documentElement.classList.add('notouchevents');
        }
    }, []);
    return (
        <Providers>
            <>
                <Content />
                <Toast />
            </>
        </Providers>
    );
}

function Providers(props: { children: JSX.Element }) {
    return (
        <LocaleProvider init={typeof localStorage !== 'undefined' ? localStorage.getItem('lang') || undefined : undefined}>
            <HelmetProvider>
                <CrumbsProvider>
                    <PayloadProvider>
                        <TagProvider>
                            {props.children}
                        </TagProvider>
                    </PayloadProvider>
                </CrumbsProvider>
            </HelmetProvider>
        </LocaleProvider>
    );
}

function Content() {
    const {0: payload} = usePayload();
    return payload?.admin ? (
        <>
            <Header />
            <Nav />
            <main className="main-content">
                <Routes>
                    <Route index path="/" element={<Dashboard />} />
                    <Route path="/inventory/shipment" element={<Shipment />} />
                    <Route path="/inventory/purchase-order" element={<PurchaseOrderInventory />} />
                    <Route path="/config/general" element={<ConfigGeneral />} />
                    <Route path="/config/email" element={<ConfigEmail />} />
                    <Route path="/config/stock" element={<ConfigStock />} />
                    <Route path="/config/inventory" element={<ConfigInventory />} />
                    <Route path="/config/api" element={<ConfigAPI />} />
                    <Route path="/email/queue" element={<EmailQueue />} />
                    <Route path="/email/template" element={<EmailTmplGrid />} />
                    <Route path="/email/template/edit" element={<EmailTmplEdit />} />
                    <Route path="/bin" element={<Rack />} />
                    <Route path="/bin/history" element={<History />} />
                    <Route path="/bin/inventory" element={<Inventory />} />
                    <Route path="/stock/dispatch" element={<Dispatch />} />
                    <Route path="/user" element={<UserGrid />} />
                    <Route path="/user/edit" element={<UserEdit />} />
                    <Route path="/user/me" element={<Me />} />
                    <Route path="/user/logs" element={<Logs />} />
                    <Route path="/role" element={<RoleGrid />} />
                    <Route path="/role/edit" element={<RoleEdit />} />
                    <Route path="/forecast" element={<Forecast />} />
                    <Route path="/purchase-order" element={<PurchaseOrders />} />
                    <Route path="/purchase-order/edit" element={<PurchaseOrder editable />} />
                    <Route path="/purchase-order/view" element={<PurchaseOrder editable={false} />} />
                    <Route path="/sales-order" element={<SalesOrders />} />
                    <Route path="/sales-order/edit" element={<SalesOrder editable />} />
                    <Route path="/sales-order/view" element={<SalesOrder editable={false} />} />
                    <Route path="/sales-shipment" element={<SalesShipments />} />
                    <Route path="/sales-shipment/edit" element={<SalesShipment editable />} />
                    <Route path="/sales-shipment/view" element={<SalesShipment editable={false} />} />
                    <Route path="/credit-memo" element={<CreditMemos />} />
                    <Route path="/credit-memo/edit" element={<CreditMemo editable />} />
                    <Route path="/credit-memo/view" element={<CreditMemo editable={false} />} />
                    <Route path="/supplier" element={<Suppliers />} />
                    <Route path="/supplier/edit" element={<Supplier />} />
                </Routes>
            </main>
        </>
    ) : (
        <Login />
    );
}
